// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jobs{list-style:none}.job-listing{margin-bottom:20px}.job-listing div{color:#00884e}.job-listing h4{margin-bottom:3px}.job-listing h4 a{text-decoration:none}.job-listing h4 a:hover{text-decoration:underline}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
